import axios from 'axios';

const getVenda = (idVenda) => axios.get(`fornecedor/compras-conjuntas/${idVenda}`);

export default {
  getVenda,
};
